module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal",
    class: _vm.type,
    attrs: {
      "id": _vm.id
    }
  }, [_c('vue-audio', {
    ref: "closeModal",
    attrs: {
      "file": 3,
      "redirect": _vm.redirect
    }
  }), _vm._v(" "), (_vm.type === 'alert') ? [_c('button', {
    staticClass: "modal__button--close",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal__table"
  }, [_c('div', {
    staticClass: "modal__cell"
  }, [_c('div', {
    staticClass: "modal__box"
  }, [_c('div', {
    staticClass: "modal__table"
  }, [_c('div', {
    staticClass: "modal__cell"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message[_vm.id])
    }
  }), _vm._v(" "), (_vm.type === 'confirm') ? [_c('p', {
    staticClass: "modal__row"
  }, [_c('button', {
    staticClass: "modal__button",
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("YES")]), _vm._v(" "), _c('button', {
    staticClass: "modal__button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("NO")])])] : _vm._e()], 2)])])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92a20036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 86
// module chunks = 0